import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TableService {
  private dataSource = new BehaviorSubject<any[]>([]);
  private filteredData = new BehaviorSubject<any[]>([]);
  private currentPageSubject = new BehaviorSubject<number>(1);
  private pageSizeSubject = new BehaviorSubject<number>(10);
  private totalPagesSubject = new BehaviorSubject<number>(0);

  currentPage$ = this.currentPageSubject.asObservable();
  totalPages$ = this.totalPagesSubject.asObservable();

  constructor() {
    this.dataSource.subscribe(data => {
      this.filteredData.next(data);
      this.updatePagination();
    });
  }

  setData(data: any[]) {
    this.dataSource.next(data);
  }

  getData(): Observable<any[]> {
    return this.filteredData.asObservable();
  }

  searchData(searchTerm: string) {
    const filteredData = this.dataSource.value.filter(item => {
      return item.name.toLowerCase().includes(searchTerm.toLowerCase());
    });
    this.filteredData.next(filteredData);
    this.currentPageSubject.next(1);
    this.updatePagination();
  }

  sortData(column: string, direction: 'asc' | 'desc') {
    const sortedData = this.filteredData.value.sort((a, b) => {
      if (direction === 'asc') {
        return a[column].localeCompare(b[column]);
      } else {
        return b[column].localeCompare(a[column]);
      }
    });
    this.filteredData.next(sortedData);
  }

  goToPage(page: number) {
    this.currentPageSubject.next(page);
  }

  goToFirstPage() {
    this.currentPageSubject.next(1);
  }

  goToLastPage() {
    this.currentPageSubject.next(this.totalPagesSubject.value);
  }

  goToPreviousPage() {
    if (this.currentPageSubject.value > 1) {
      this.currentPageSubject.next(this.currentPageSubject.value - 1);
    }
  }

  goToNextPage() {
    if (this.currentPageSubject.value < this.totalPagesSubject.value) {
      this.currentPageSubject.next(this.currentPageSubject.value + 1);
    }
  }

  loadMore() {
    this.pageSizeSubject.next(this.pageSizeSubject.value + 10);
    this.updatePagination();
  }

  private updatePagination() {
    const startIndex = (this.currentPageSubject.value - 1) * this.pageSizeSubject.value;
    const endIndex = startIndex + this.pageSizeSubject.value;
    const paginatedData = this.filteredData.value.slice(startIndex, endIndex);
    this.filteredData.next(paginatedData);
    this.totalPagesSubject.next(Math.ceil(this.dataSource.value.length / this.pageSizeSubject.value));
  }
}
